import React, { ReactNode } from 'react';
import { useTableInstance } from '@panwds/react-table';
import { Data } from '@panwds/react-table';

interface BatchActionsProps {
  children: (selectedRows: Data[], tableInstance: any) => ReactNode;
  position?: 'left' | 'right';
}

export const BatchActions: React.FC<BatchActionsProps> = ({
  children,
  position = 'right'
}) => {
  const tableInstance = useTableInstance();

  // Get selected rows from table instance

  const selectedRows = (tableInstance as any)?.selectedFlatRows?.map((row: any) => row.original) || [];

  // Render children as a function with selectedRows and tableInstance
  const content = children(selectedRows, tableInstance);

  return <>{content}</>;
};
